import React from "react"
import Authenticated from "./Authenticated"
import { LEGAL_CONST } from "./constants"
import Unauthenticated from "./Unauthenticated"

export default ({
  loggedIn,
  history,
  ssoEnabled = false,
  legalConst = LEGAL_CONST,
}: {
  loggedIn: boolean | null
  history: { push: Function }
  legalConst: string
  ssoEnabled: boolean
}) => {
  if (loggedIn === null) return null
  return (
    <div className="not-verified-wrapper-with-margin">
      <div>
        <h1 className="legal-title">{LEGAL_CONST.toUpperCase()}</h1>
        <br />
        <div className="display-flex">
          {loggedIn ? (
            <Authenticated history={history} />
          ) : (
            <Unauthenticated
              history={history}
              legalConst={legalConst}
              ssoEnabled={ssoEnabled}
            />
          )}
        </div>
      </div>
    </div>
  )
}
